import React from 'react';

import { ApplicationRoutes, FRAGNET_SEARCH_ROLE } from 'common/constants';
import DocsRoute from 'components/Docs/DocsRoute';
import HomeView from 'components/HomeView';
import NotFoundPage from 'components/navigation/404';
import Loader from 'components/navigation/Loader';
import Navbar from 'components/navigation/Navbar';
import ResultsView from 'features/searchMolecules/ResultsView/ResultsView';
import { getSearchResultsCount } from 'features/searchMolecules/searchMoleculesSlice';
import SearchView from 'features/searchMolecules/SearchView/SearchView';
import CartView from 'features/shoppingCart/CartView';
import { useAuth } from 'hooks';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';

import HomeIcon from '@material-ui/icons/Home';
import PagesIcon from '@material-ui/icons/Pages';
import SearchIcon from '@material-ui/icons/Search';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';

const HomeRoute = () => {
  const searchResultsCount = useSelector(getSearchResultsCount);

  const { roles } = useAuth();
  const hasRole = !!roles?.includes(FRAGNET_SEARCH_ROLE);

  const tabs = [
    {
      name: 'home',
      icon: <HomeIcon />,
      route: ApplicationRoutes.Base,
      content: <HomeView />,
      protected: false,
      exact: true,
    },
    {
      name: 'query',
      icon: <SearchIcon />,
      route: ApplicationRoutes.Query,
      content: <SearchView />,
      isDisabled: !hasRole,
      protected: true,
      exact: true,
    },
    {
      name: 'results',
      icon: <ViewComfyIcon />,
      route: ApplicationRoutes.Results,
      content: <ResultsView />,
      isDisabled: searchResultsCount === 0 || !hasRole,
      protected: true,
      exact: true,
    },
    {
      name: 'carts',
      icon: <ShoppingCartIcon />,
      route: ApplicationRoutes.Carts,
      content: <CartView />,
      isDisabled: !hasRole,
      protected: true,
      exact: true,
    },
    {
      name: 'docs',
      icon: <PagesIcon />,
      route: ApplicationRoutes.Docs,
      content: <DocsRoute />,
      protected: false,
      exact: false,
    },
  ];

  const { isAuthenticated, initialized, keycloak } = useAuth();

  return (
    <>
      <Navbar tabs={tabs.filter((t) => !!isAuthenticated || !t.protected)} />
      <Switch>
        {tabs.map((tab, index) => {
          const props = {
            exact: tab.exact,
            path: tab.route,
          };

          if (tab.protected) {
            return (
              <Route
                key={index}
                {...props}
                render={() => {
                  if (tab.isDisabled) {
                    return <Redirect to={ApplicationRoutes.Base} />;
                  } else if (initialized && isAuthenticated && keycloak?.token) {
                    return tab.content;
                  } else if (initialized && !isAuthenticated) {
                    keycloak?.login();
                  }
                  return <Loader reason="loading" open={true} />;
                }}
              />
            );
          }
          return <Route key={index} {...props} render={() => tab.content} />;
        })}
        <Route path="*" key={tabs.length}>
          <NotFoundPage />
        </Route>
      </Switch>
    </>
  );
};

export default HomeRoute;
